export const GET_USERS = 'GET_USERS';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILED = 'GET_USERS_FAILED';

export const ADD_USER = 'ADD_USER';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_FAILED = 'ADD_USER_FAILED';

export const EDIT_USER = 'EDIT_USER';
export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
export const EDIT_USER_FAILED = 'EDIT_USER_FAILED';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILED = 'DELETE_USER_FAILED';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILED = 'UPDATE_USER_FAILED';

export const UPDATE_PROFILE_LOGO = 'UPDATE_PROFILE_LOGO';
export const UPDATE_PROFILE_LOGO_SUCCESS = 'UPDATE_PROFILE_LOGO_SUCCESS';
export const UPDATE_PROFILE_LOGO_FAILED = 'UPDATE_PROFILE_LOGO_FAILED';

export const GET_PARTIAL_USER = 'GET_PARTIAL_USER';
export const GET_PARTIAL_USER_SUCCESS = 'GET_PARTIAL_USER_SUCCESS';
export const GET_PARTIAL_USER_FAILED = 'GET_PARTIAL_USER_FAILED';

export const GET_COMPANIES = 'GET_COMPANIES';
export const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS';
export const GET_COMPANIES_FAILED = 'GET_COMPANIES_FAILED';

export const DELETE_COMPANIES_DATA = 'DELETE_COMPANIES_DATA';
export const DELETE_COMPANIES_DATA_SUCCESS = 'DELETE_COMPANIES_DATA_SUCCESS';
export const DELETE_COMPANIES_DATA_FAILED = 'DELETE_COMPANIES_DATA_FAILED';

export const UPDATE_SIGNATURE = 'UPDATE_SIGNATURE';
export const UPDATE_SIGNATURE_SUCCESS = 'UPDATE_SIGNATURE_SUCCESS';
export const UPDATE_SIGNATURE_FAILED = 'UPDATE_SIGNATURE_FAILED';
